package team.platforma.chat_data.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateChatResponse(
    @SerialName("account_id") val accountId: Long,
    @SerialName("ai_model_id") val aiModelId: Long,
    @SerialName("chat_id") val chatId: Long,
    @SerialName("created_at") val createdAt: String,
//   @SerialName("deleted_at") val deleted_at: Any,
//   @SerialName("title") val title: String
)